export default __webpack_public_path__ + "static/media/spain.6ae9e2f5.svg";